/**
 * Dummy sections for layout edit mode.
 * Will be replaced by backend-provided sections later.
 */
export const EDIT_MODE_SECTIONS = [
  { section_slug: 'first-section', section_title: 'First Section', section_order: 0 },
  { section_slug: 'second-section', section_title: 'Second Section', section_order: 1 },
  { section_slug: 'no-section', section_title: 'No Section', section_order: 2 },
] as const;

export type EditModeSectionSlug = (typeof EDIT_MODE_SECTIONS)[number]['section_slug'];
